import React from 'react';
import MainInfoTracLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/CertifiedMail';

function CertifiedMail() {
  return (
    <MainInfoTracLayout className="min-h-[100vh]">
      <Content />
    </MainInfoTracLayout>
  );
}

export default CertifiedMail;
